<app-cookie [canDecline]="false">
</app-cookie>

<app-menu-container
  [links]="links"
  [currentRoute]="currentRoute"
  [hasPhoneNumber]=true
>
</app-menu-container>

<app-expandable-contact-form>
</app-expandable-contact-form>

<app-expandable-contact-form-mobile>
</app-expandable-contact-form-mobile>

<router-outlet></router-outlet>

<app-footer></app-footer>

<div
  class="contact-footer"
  fxLayout="row"
>
  <div fxFlex></div>
  <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div>
      <a
        fxFlex
        [href]="'https://wa.me/' + agencyService.agency.phone"
        target="_blank"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="phone_click"
        appFbqEvent="Contact"
        [customData]="{content_name: 'phone_click', content_category: 'click'}"
        class="mobile-phone-contact whatsapp"
      >
        <img
          src="/assets/icons/contact/whatsapp.svg"
          alt="WhatsApp"
          class="phone-icon"
          loading="lazy"
        >
      </a>
    </div>

    <div>
      <a
        fxFlex
        [href]="'tel:' + agencyService.agency.phone"
        target="_blank"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="phone_click"
        appFbqEvent="Contact"
        [customData]="{content_name: 'phone_click', content_category: 'click'}"
        class="mobile-phone-contact phone"
      >
        <img
          src="/assets/icons/contact/phone.svg"
          alt="Phone"
          class="phone-icon"
        >
      </a>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html